import React, { useState } from 'react';
import { Amplify } from 'aws-amplify';
import { Authenticator, useAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import './App.css';
import Overview from './components/Overview';
import IngredientLibrary from './components/IngredientLibrary';
import RecipeLibrary from './components/RecipeLibrary';
import ProductionTracking from './components/ProductionTracking';
import Analytics from './components/Analytics';
import DemoArchitecture from './components/DemoArchitecture';
import { awsConfig } from './aws-config';

Amplify.configure(awsConfig);

function AppContent() {
  const [currentPage, setCurrentPage] = useState('overview');
  const [showLogin, setShowLogin] = useState(false);
  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const isAuthenticated = !!user;

  if (showLogin && !isAuthenticated) {
    return (
      <div className="login-container">
        <Authenticator>
          {() => {
            setShowLogin(false);
            return <></>;
          }}
        </Authenticator>
      </div>
    );
  }

  return (
    <div className="App">
      <header className="App-header">
        <div className="header-top">
          <h1>🍫 Product Carbon Footprint</h1>
          <div className="header-user">
            {isAuthenticated ? (
              <>
                <span>{user?.signInDetails?.loginId}</span>
                <button onClick={signOut} className="btn-signout">Sign Out</button>
              </>
            ) : (
              <button onClick={() => setShowLogin(true)} className="btn-login">Login to Edit</button>
            )}
          </div>
        </div>
        <nav>
          <div className="nav-left">
            <button 
              className={currentPage === 'overview' ? 'active' : ''}
              onClick={() => setCurrentPage('overview')}
            >
              Overview
            </button>
            <button 
              className={currentPage === 'ingredients' ? 'active' : ''}
              onClick={() => setCurrentPage('ingredients')}
            >
              Ingredient Library
            </button>
            <button 
              className={currentPage === 'recipes' ? 'active' : ''}
              onClick={() => setCurrentPage('recipes')}
            >
              Recipe Library
            </button>
            <button 
              className={currentPage === 'production' ? 'active' : ''}
              onClick={() => setCurrentPage('production')}
            >
              Production Tracking
            </button>
            <button 
              className={currentPage === 'analytics' ? 'active' : ''}
              onClick={() => setCurrentPage('analytics')}
            >
              Analytics
            </button>
          </div>
          <button 
            className={currentPage === 'demo-architecture' ? 'active' : ''}
            onClick={() => setCurrentPage('demo-architecture')}
          >
            Demo Architecture
          </button>
        </nav>
      </header>

      <main>
        {currentPage === 'overview' && <Overview />}
        {currentPage === 'ingredients' && <IngredientLibrary readOnly={!isAuthenticated} />}
        {currentPage === 'recipes' && <RecipeLibrary readOnly={!isAuthenticated} />}
        {currentPage === 'production' && <ProductionTracking readOnly={!isAuthenticated} />}
        {currentPage === 'analytics' && <Analytics />}
        {currentPage === 'demo-architecture' && <DemoArchitecture />}
      </main>
    </div>
  );
}

function App() {
  return (
    <Authenticator.Provider>
      <AppContent />
    </Authenticator.Provider>
  );
}

export default App;
